module.exports = __webpack_public_path__ + "static/media/map.8c62c3e6.png";